export default __webpack_public_path__ + "static/media/logmatic.75e51e92.svg";